const FillMapIcon = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="#E1E1E4" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8414 6.79093C17.9187 6.5747 17.8551 6.33321 17.6814 6.18302C17.5077 6.03284 17.2596 6.00484 17.0568 6.11254L6.52067 11.7079C6.31169 11.8189 6.19581 12.05 6.23184 12.2838C6.26787 12.5177 6.44792 12.7031 6.68061 12.7461L11.274 13.5937L12.7762 18.0165C12.8523 18.2405 13.0619 18.3919 13.2985 18.3938C13.5351 18.3956 13.747 18.2476 13.8266 18.0248L17.8414 6.79093Z"
        fill="#222223"
      />
    </svg>
  )
}

export default FillMapIcon
